import { BrowserModule } from '@angular/platform-browser';
import { NgModule, LOCALE_ID } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import { TokenInterceptor } from './backoffice/token.interceptor2';
import { ServiceWorkerModule } from '@angular/service-worker';
import { DialogModule } from 'primeng/dialog';
import { ToastModule } from 'primeng/toast';
import { ButtonModule } from 'primeng/button';
import { NotifInterceptor } from './notif.interceptor';
import { environment } from "../environments/environment";
import { providePrimeNG } from 'primeng/config';
import { definePreset } from '@primeuix/themes';
import Lara from '@primeuix/themes/lara';
import { MessageService } from 'primeng/api';
// import { StringToDatePipe } from './string-to-date.pipe';
registerLocaleData(localeFr, 'fr');

const MyLaraVioletPreset = definePreset(Lara, {
    semantic: {
        primary: {
            50: '#f7f1f7',
            100: '#e7d0e7',
            200: '#d6add6',
            300: '#c389c3',
            400: '#a95fa8',
            500: '#541554',
            600: '#4a124a',
            700: '#3f0f3f',
            800: '#340d34',
            900: '#290a29',
            950: '#180418'
        }
    }
});


@NgModule({ declarations: [
        AppComponent,
        // StringToDatePipe
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        DialogModule,
        ToastModule,
        ButtonModule,
        AppRoutingModule,
        ReactiveFormsModule,
        FormsModule,
        ServiceWorkerModule.register('ngsw-worker.js', {
            enabled: environment.production,
            // Register the ServiceWorker immediately
            registrationStrategy: 'registerImmediately'
        })], providers: [
        MessageService,
        provideAnimationsAsync(),
        { provide: LOCALE_ID, useValue: 'fr' },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: TokenInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: NotifInterceptor,
            multi: true
        },
        provideHttpClient(withInterceptorsFromDi()),
        providePrimeNG({
            theme: {
                preset: MyLaraVioletPreset,
                options: {
                    darkModeSelector: '.app-dark',
                    cssLayer: {
                        name: 'primeng',
                        order: 'theme, base, primeng'
                    }
                }
            },
            translation: {
                firstDayOfWeek: 1,
                dayNames: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'],
                dayNamesShort: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
                dayNamesMin: ['Di', 'Lu', 'Ma', 'Me', 'Je', 'Ve', 'Sa'],
                monthNames: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
                monthNamesShort: ['Jan', 'Fév', 'Mar', 'Avr', 'Mai', 'Jun', 'Jul', 'Aoû', 'Sep', 'Oct', 'Nov', 'Déc'],
                today: "Aujourd'hui",
                clear: 'Effacer',
                dateFormat: 'dd/mm/yy',
                weekHeader: 'Sem'
            }
        })
    ] })
export class AppModule { }


